import Vue from "vue";
import Vuex from "vuex";
import {get} from '../requests'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tolietyw: {
      id: null,
      name: "",
      openTime: "",
      lng: null,
      lat: null,
      closeTime: "",
      phone: null,
      manager: null,
      occupancyNum: null,
    },
    toiletinfo: []
  },
  mutations: {
    STEYW(state,parameter){
      state.tolietyw = {
        id: null,
        name: "",
        openTime: "",
        lng: null,
        lat: null,
        closeTime: "",
        phone: null,
        manager: null,
        occupancyNum: null,
      };
      if(parameter){
        state.tolietyw = parameter;
      }

    },
    STEINFO(state, parameter) {
      state.toiletinfo = parameter;
    }
  },
  actions: {
    gettolietyw(context, parameter) {
      get("toiletInfo/view", {id: parameter}).then((res) => {
       context.commit('STEYW', res.data.data)
      })

    },
    gettoiletinfo(context, parameter) {
      get("toiletInfo/list", {}).then((res) => {
        context.commit('STEINFO', res.data.rows)
      });
    }
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js